export function listSupportedCountriesV3(send) {
  return (...args) =>
    send(
      {
        path: '/v3/supportedCountries',
        pathParameters: {},
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: undefined,
        contentType: undefined,
      },
      ...args
    );
}
